const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class TripleCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onCarouselUpdated = this.onCarouselUpdated.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.35,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        created: this.onCarouselUpdated,
        updated: this.onCarouselUpdated,
      },
      [setInitialised()],
    )
  }

  onCarouselUpdated (instance) {
    this.els.slides.element.setAttribute(
      `data-active-carousel`,
      instance.track.details.length !== 0,
    )
  }
}

if (!customElements.get('triple-cta')) {
  customElements.define('triple-cta', TripleCta)
}
